enum CustomerStatus {
  NONE = 0,
  PENDING = 1,
  APPROVED = 2,
  BLOCKED = 3
}

export default CustomerStatus;
